import React from "react";
import "./preorder.css";

const Preorder = () => {
  return (
    <div className="preorder-page">
      <div className="preorder-page-content">
        <h2>Place Your Preorder</h2>
        <p>
          Call us at <span className="phone">(519) 731-8223</span> to place your order!
        </p>
      </div>
    </div>
  );
};

export default Preorder;
